// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconShipping = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M15 7H3V5h14v4h3l3 4.5V19h-2a2 2 0 11-4 0H9a2 2 0 11-4 0H3v-2h12zm2 10v-6h1.93L21 14.106V17z"
    />,
    <path d="M1 11V9h10v2zm0 4v-2h8v2z" />
  );
export default SvgIconShipping;
